import { render, staticRenderFns } from "./BusinessContactTopicEdit.vue?vue&type=template&id=53d9f6f2"
import script from "./BusinessContactTopicEdit.vue?vue&type=script&lang=js"
export * from "./BusinessContactTopicEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports